var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-alert',{staticStyle:{"font-size":"13px"},attrs:{"outline":"","type":"error","value":_vm.error !== null,"transition":"slide-y"}},[_vm._v(_vm._s(_vm.error))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }